// import { csrfFetch } from "./csrf"; // No longer needed for frontend-only mode
//create, read, update, delete

//------------------------------create comments---------------------------------
const ADD_COMMENT = "comments/ADD"
export const addComment = (comment) => ({
  type: ADD_COMMENT,
  comment
});

export const postComment = (comment) => async (dispatch) => {
  // For frontend-only demo, simulate creating a new comment
  const new_comment = {
    id: Date.now(),
    ...comment,
    username: 'demo_user',
    created_at: new Date().toISOString()
  };

  dispatch(addComment(new_comment));
}

//------------------------------read comments---------------------------------
const LOAD_COMMENTS = "comments/LOAD";
export const loadComments = (comments) => ({
  type: LOAD_COMMENTS,
  comments
})

export const getComments = (payment_id) => async(dispatch) => {
  // For frontend-only demo, return mock comments
  const mockComments = {
    comments: [
      {
        id: 1,
        text: "Thanks for the coffee! ☕",
        payment_id: payment_id,
        user_id: 2,
        username: "alice_smith",
        created_at: new Date().toISOString()
      },
      {
        id: 2,
        text: "You're welcome! 😊",
        payment_id: payment_id,
        user_id: 1,
        username: "demo_user",
        created_at: new Date().toISOString()
      }
    ]
  };
  dispatch(loadComments(mockComments));
}

//------------------------------update comments---------------------------------
const UPDATE_COMMENT = "comments/UPDATE";
export const updateComment = updatedComment => ({
  type:UPDATE_COMMENT,
  updatedComment
})

export const updatingComment = comment => async(dispatch) => {
  // For frontend-only demo, simulate updating a comment
  const updatedComment = {
    ...comment,
    updated_at: new Date().toISOString()
  };
  
  dispatch(updateComment(updatedComment));
  return updatedComment;
}

//------------------------------delete comment---------------------------------
const DELETE_COMMENT = "comments/DELETE";
export const removeComment = removedComment => ({
  type: DELETE_COMMENT,
  removedComment
})

export const deleteComment = comment_id => async(dispatch) => {
  // For frontend-only demo, simulate deleting a comment
  const commentNum = { comment_id };
  dispatch(removeComment(commentNum));
}

//------------------------------comments reducer---------------------------------
const commentReducer = (state = {}, action) => {
  let newState = { ...state };

  switch(action.type) {
    case LOAD_COMMENTS:
      if (action.comments) {
        action.comments.comments.forEach(
          (comment) => (newState[comment.id] = comment)
        );
      } else {
        newState = {}
      }
      return newState;
    case ADD_COMMENT: {
      newState[action.comment.id] = action.comment;

      return newState;
    }
    case UPDATE_COMMENT: {
      newState[action.updatedComment.id] = action.updatedComment;

      return newState;
    }
    case DELETE_COMMENT:
      delete newState[action.removedComment.comment_id];

      return newState;
    default:
      return state;
  }
}

export default commentReducer;
